import React, { useEffect } from 'react'
import { useCookies } from 'react-cookie'
import { useLocation } from 'react-router'
import { NavLink, useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'

import header_person from '@/assets/common/header_icon.png'
import mo_header_logo from '@/assets/common/mo_header_logo.png'
import { TYPE_LOGOUT, TYPE_SESSION } from '@/shared/constant/cmdtype'
import { COLOR } from '@/shared/constant/color'
import { SERVICE_JOIN_URL } from '@/shared/constant/url'
import { UserLogoutQueryData, UserSessionQueryData } from '@/shared/hooks/reactquery'
import { HeaderUserTab, MoHeaderMenuToggle } from '@/shared/store'
import {
  MoHeaderContent,
  MoHeaderContentInner,
  MoHeaderIcon,
  MoHeaderMenu,
  MoHeaderMenuItem,
  MoHeaderTab,
  MoHeaderUserTab,
  MoHeaderWrap,
} from '@/styles/common/header'

const UserSubTab = [
  { title: '마이페이지', link: '/userPage/main' },
  { title: '패밀리레터', link: '/userPage/letter/health' },
  { title: '오늘의 운세', link: '/userPage/fortune' },
]

const MoHeader = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const [UserTab, setUserTab] = useRecoilState(HeaderUserTab)
  const [menuToggle, setMenuToggle] = useRecoilState(MoHeaderMenuToggle)
  const [cookies, , removeCookie] = useCookies(['Famliycare'])
  const { mutateAsync: UserLogout } = UserLogoutQueryData(TYPE_LOGOUT, cookies?.Famliycare)
  const { data: UserSession, isSuccess } = UserSessionQueryData(TYPE_SESSION, cookies?.Famliycare)
  const loginStatus = UserSession?.Header?.ErrMsg === '정상' && cookies?.Famliycare !== undefined
  const PageNavFunc = (link: string) => {
    navigate(link)
    setMenuToggle(false)
  }
  const Logout = () => {
    UserLogout()
      .then(async (r) => {
        await removeCookie('Famliycare', { path: '/' })
        navigate('/')
        setUserTab(false)
      })
      .catch(() => {
        window.location.reload()
      })
  }
  useEffect(() => {
    if (isSuccess) {
      switch (true) {
        case !loginStatus && pathname.includes('/userPage'):
        case loginStatus && pathname.includes('/login'):
          return navigate('/')
      }
    }
  }, [isSuccess, loginStatus, navigate, pathname])

  useEffect(() => {
    setMenuToggle(false)
    setUserTab(false)
  }, [pathname, setMenuToggle, setUserTab])

  return (
    <MoHeaderWrap>
      <MoHeaderTab>
        <img src={mo_header_logo} alt="" onClick={() => navigate('/')} />
        <section>
          {isSuccess && loginStatus ? (
            <img
              src={header_person}
              alt={'direct_userpage'}
              onClick={() => setUserTab((prev) => !prev)}
            />
          ) : (
            <button onClick={() => navigate('/login')}>로그인</button>
          )}
          <MoHeaderIcon
            active={`${menuToggle}`}
            onClick={() => {
              setMenuToggle((prev) => !prev)
              setUserTab(false)
            }}
          >
            <div className="burger_line1" />
            <div className="burger_line2" />
            <div className="burger_line3" />
          </MoHeaderIcon>
        </section>
      </MoHeaderTab>
      <MoHeaderContent
        active={`${menuToggle}`}
        onClick={() => {
          setMenuToggle(false)
        }}
      >
        <MoHeaderContentInner active={`${menuToggle}`} onClick={(e) => e.stopPropagation()}>
          <MoHeaderMenu>
            <MoHeaderMenuItem onClick={() => PageNavFunc('/')}>Home</MoHeaderMenuItem>
            <MoHeaderMenuItem
              onClick={() => {
                setMenuToggle(false)
                window.location.href = SERVICE_JOIN_URL
              }}
            >
              서비스 가입
            </MoHeaderMenuItem>
            <MoHeaderMenuItem onClick={() => PageNavFunc('/notice')}>고객지원</MoHeaderMenuItem>
            <MoHeaderMenuItem onClick={() => PageNavFunc('/cancel')}>서비스 해지</MoHeaderMenuItem>
          </MoHeaderMenu>
        </MoHeaderContentInner>
      </MoHeaderContent>
      <MoHeaderUserTab display={`${UserTab}`}>
        {UserSubTab.map((element: any, index: number) => (
          <NavLink
            to={element.link}
            key={index}
            style={{
              color: `${pathname.indexOf(element.link) >= 0 ? COLOR.gray50 : COLOR.gray40}`,
            }}
          >
            {element.title}
          </NavLink>
        ))}
        <p onClick={Logout}>로그아웃</p>
      </MoHeaderUserTab>
    </MoHeaderWrap>
  )
}
export default MoHeader
